// import PropTypes from "prop-types";
import React, { Fragment, FC, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";

import { Header } from "../components";
import { Footer } from "../components";
import { getAnnoucement, clearAnnoucement } from "../store/action/annoucement";
// import { refreshToken } from "../store/action/user";
// import jwt_decode from "jwt-decode";

// import { getCookie } from "../helpers/cookies";
// import { setAxiosClientInterceptor } from "../helpers/apiClient";
interface PropType {
  children: React.ReactNode
}

const DefaultLayout: FC<PropType> = ({ children }) => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const isAuth = useAppSelector((state)=>state.user.isAuth)

  // const refreshTkn = useCallback(async () => {
  //   const response = await dispatch(refreshToken()).unwrap();
  //   if (response.isAuth) {
  //     setAxiosClientInterceptor();
  //   }
  // }, []);

  // const validateToken = useCallback(async () => {
  //   const authToken = getCookie("authToken");
  //   if (authToken) {
  //     //check expiry
  //     type authContent = {
  //       unique_name: string;
  //       nbf: number;
  //       exp: number;
  //       iat: number;
  //     };
  //     const content: authContent = jwt_decode(authToken);

  //     const nowDate = new Date();
  //     if (nowDate.getTime() > content.exp) {
  //       refreshTkn();
  //     } else {
  //       setAxiosClientInterceptor();
  //     }

  //     return;
  //   }

  //   refreshTkn();
  // }, [])

  useEffect(()=>{
    // validateToken();

    if (isAuth) {
      dispatch(getAnnoucement())
    } else {
      dispatch(clearAnnoucement()) 
    }
    
  }, [location])

  // useEffect(() => {
  //   validateToken();
  // }, []);

  return (
    <Fragment>
      <Header />
        <div style={{touchAction: "manipulation"}}>
          {children}
        </div>
      <Footer />
    </Fragment>
  );
};

export default DefaultLayout;
